module.exports = __webpack_public_path__ + "static/media/blue-small-10.b37c2140.png";